import { FC, useState, useEffect } from 'react';
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useBossStore } from '../../hooks/useBossStore';
import { BossMaintenance } from '../../types/slices/bossMaintenanceType';
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { useSelector } from "react-redux";
import { IdentificationModalAdmin } from '../MyProfile/components/IdentificationModalAdmin';
import { useAuthStore } from '../../hooks';
import { Role } from '../../types/roles/roleTypes';
import { useUserStore } from "../../hooks/useUserStore";
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { ApiStatus } from '../../types/api/status';

const columns = [
    { type: "options", field: "options", label: "OPCIONES", align: 'center' },
    { type: "text", field: "rut", label: "RUT", align: 'center' },
    { type: "text", field: "name", label: "NOMBRES", align: 'center' },
    { type: "text", field: "surname", label: "APELLIDOS", align: 'center' },
    { type: "text", field: "email", label: "EMAIL", align: 'center' },
    { type: "text", field: "phone", label: "TELÉFONO", align: 'center' },
    { type: "text", field: "contrata", label: "CONTRATA", align: 'center' },
    { type: 'detail', field: 'detail', label: '', align: 'center' },
];

export const BossMaintenances: FC = () => {
    const navigate = useNavigate();
    const { user } = useAuthStore()
    const { search } = useSelector(selectHeaderState);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [rowSelected, setRowSelected] = useState<BossMaintenance>({} as BossMaintenance);
    const [modalDeleteConfirm, setModalDeleteConfirm] =
        useState<boolean>(false);
    const [showModalIdentification, setShowModalIdentification] = useState<boolean>(false)
    const [userRut, setUserRut] = useState<string>('')
    const userRole: Role | any = user.userType;

    const {
        boss,
        status: bossStatus,
        getBoss,
        setSelectedBoss,
        deleteBossStore,
    } = useBossStore();
    const { forgotPasswordUser } = useUserStore()

    useEffect(() => {
        getBossApi();
    }, [search]);

    const getBossApi = async () => {
        try {
            setLoading(true);
            let payload: any = {}
            if (search !== '') {
                payload = {
                    search
                }
            }
            await getBoss(payload);
            setLoading(false);
        } catch (error) {
            setLoading(false)
        }
    };

    const onAdd = () => {
        setSelectedBoss({} as BossMaintenance)
        navigate({ pathname: RoutesMap.BOSS_MAINTENANCE_FORM })
    };

    const onEdit = (rowSelected) => {
        setSelectedBoss(rowSelected);
        navigate({ pathname: RoutesMap.BOSS_MAINTENANCE_FORM })
    };

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected);
        setModalDeleteConfirm(true);
    };

    const onDeleteConfirm = async () => {
        const response = await deleteBossStore(rowSelected.id);
        if (response === true) {
            setSelectedBoss({} as BossMaintenance);
            setModalDeleteConfirm(false);
            getBossApi();
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const onPersonIcon = (row) => {
        setShowModalIdentification(true)
        setUserRut(row.rut)
    }

    const sendCredentials = async (rowSelected) => {
        setLoading(true)
        await forgotPasswordUser(rowSelected.rut, rowSelected.iduser_type)
        setLoading(false)
    }

    return (
        <>
            <Grid item xs={12}>
                {
                    userRole === Role.ADMIN
                    ?
                    <CustomTable
                        title={"Jefe de Mantenimiento"}
                        columns={columns}
                        loading={loading}
                        rows={boss || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onPersonIcon={onPersonIcon}
                        onHelper={sendCredentials}
                        tooltip_helper={'Enviar credenciales'}
                        icon_helper={<ContactMailIcon fontSize="small"/>}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                    :
                    <CustomTable
                        title={"Jefe de Mantenimiento"}
                        columns={columns}
                        loading={loading}
                        rows={boss || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                }
                
            </Grid>
            {modalDeleteConfirm && (
                <ModalConfirm
                    open={modalDeleteConfirm}
                    closeModal={() => {
                        setModalDeleteConfirm(false);
                    }}
                    onCancel={() => {
                        setModalDeleteConfirm(false);
                    }}
                    onConfirm={onDeleteConfirm}
                    status2={bossStatus === ApiStatus.FETCHING ? true : false}
                />
            )}
            {
                showModalIdentification && (
                    <IdentificationModalAdmin
                        open={showModalIdentification}
                        closeModal={()=>setShowModalIdentification(false)}
                        rut={userRut}
                    />
                )
            }
        </>
    );
};